<script setup lang="ts">
  import { computed } from 'vue';
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import FontIcon from '../../../FontIcon/FontIcon.vue';
  import {
    checkboxIndicatorClass,
    checkboxIndicatorIconClass,
  } from './CheckboxIndicator.css';
  import type { CheckboxIndicatorProps } from './CheckboxIndicator.types';

  const props = withDefaults(defineProps<CheckboxIndicatorProps>(), {
    checked: false,
    indeterminate: false,
    disabled: false,
  });

  const state = computed(() => {
    if (props.indeterminate) return 'indeterminate';
    return props.checked ? 'checked' : 'unchecked';
  });
</script>

<template>
  <div
    :class="checkboxIndicatorClass"
    aria-hidden="true"
    :data-state="state"
    :data-disabled="disabled ? '' : undefined"
  >
    <FontIcon
      v-if="indeterminate"
      :class="checkboxIndicatorIconClass"
      :icon-name="TUNDR_ICONS.MINUS"
    />
    <FontIcon
      v-else-if="checked"
      :class="checkboxIndicatorIconClass"
      :icon-name="TUNDR_ICONS.CHECK"
    />
  </div>
</template>
